import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

export const Route = createFileRoute("/tietosuoja")({
  head: () => ({
    meta: [
      { title: "Tietosuojaseloste — Montessori24" },
      { name: "description", content: "Montessori24 tietosuojaseloste: miten käsittelemme henkilötietojasi GDPR:n mukaisesti." },
      { property: "og:title", content: "Tietosuojaseloste — Montessori24" },
      { property: "og:description", content: "Henkilötietojen käsittely GDPR:n mukaisesti." },
      { property: "og:url", content: "https://montessori24.fi/tietosuoja" },
    ],
    links: [{ rel: "canonical", href: "https://montessori24.fi/tietosuoja" }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <Layout>
      <section className="container-prose pt-16 pb-24 md:pt-24">
        <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Lakisääteinen</span>
        <h1 className="mt-3 text-5xl text-foreground md:text-6xl text-balance">Tietosuojaseloste</h1>
        <p className="mt-6 max-w-2xl text-muted-foreground">
          Päivitetty 21.5.2026. Tämä seloste kuvaa, miten Montessori24 (MLR Solutions OY) käsittelee henkilötietojasi
          EU:n yleisen tietosuoja-asetuksen (GDPR) ja Suomen tietosuojalain mukaisesti.
        </p>

        <div className="mt-12 space-y-10 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          <div>
            <h2 className="text-foreground text-lg">1. Rekisterinpitäjä</h2>
            <p className="mt-2">
              MLR Solutions OY (Y-tunnus 3582909-7)<br />
              Helsinki, Suomi<br />
              Sähköposti: <a className="underline" href="mailto:asiakaspalvelu@montessori24.fi">asiakaspalvelu@montessori24.fi</a>
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">2. Käsiteltävät henkilötiedot</h2>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Yhteystiedot: nimi, osoite, sähköposti, puhelinnumero</li>
              <li>Tilaustiedot: tilatut tuotteet, tilausnumero, tilaushistoria</li>
              <li>Maksutiedot: maksutapa (varsinaisia korttitietoja ei tallenneta meille — maksunvälittäjä käsittelee ne)</li>
              <li>Tekniset tiedot: IP-osoite, selain, evästetunnisteet, käyttölokit</li>
              <li>Asiakaspalveluviestintä</li>
            </ul>
          </div>

          <div>
            <h2 className="text-foreground text-lg">3. Käyttötarkoitukset ja oikeusperuste</h2>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Tilausten käsittely ja toimitus (sopimuksen täyttäminen)</li>
              <li>Asiakaspalvelu ja reklamaatiot (sopimus ja oikeutettu etu)</li>
              <li>Kirjanpito ja lakisääteiset velvoitteet (lakisääteinen velvoite)</li>
              <li>Markkinointi ja uutiskirjeet (suostumus)</li>
              <li>Verkkokaupan kehittäminen ja analytiikka (oikeutettu etu)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-foreground text-lg">4. Tietojen säilytysaika</h2>
            <p className="mt-2">
              Tilaustiedot säilytetään kirjanpitolain mukaisesti vähintään 6 vuotta. Markkinointisuostumukseen
              perustuvat tiedot säilytetään kunnes suostumus peruutetaan. Asiakaspalveluviestit säilytetään
              tyypillisesti 2 vuotta.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">5. Tietojen luovutukset ja siirrot</h2>
            <p className="mt-2">
              Luovutamme tietoja vain tarpeen mukaan luotettaville kumppaneille, kuten maksunvälittäjille (esim. Stripe),
              kuljetusyhtiöille (esim. Posti) sekä IT-palveluntarjoajille. Osa palveluntarjoajista voi käsitellä tietoja
              EU/ETA-alueen ulkopuolella, jolloin käytämme EU:n vakiosopimuslausekkeita tai vastaavia suojatoimia.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">6. Rekisteröidyn oikeudet</h2>
            <p className="mt-2">
              Sinulla on oikeus tarkastaa sinusta tallennetut tiedot, vaatia niiden oikaisua tai poistamista, rajoittaa
              tai vastustaa käsittelyä, siirtää tiedot järjestelmästä toiseen sekä peruuttaa suostumus milloin tahansa.
              Voit käyttää oikeuksiasi ottamalla yhteyttä:{" "}
              <a className="underline" href="mailto:asiakaspalvelu@montessori24.fi">asiakaspalvelu@montessori24.fi</a>.
            </p>
            <p className="mt-2">
              Sinulla on lisäksi oikeus tehdä valitus tietosuojavaltuutetun toimistolle (tietosuoja.fi), jos koet
              käsittelyn olevan tietosuojalainsäädännön vastaista.
            </p>
          </div>

          <div>
            <h2 className="text-foreground text-lg">7. Tietoturva</h2>
            <p className="mt-2">
              Sivusto käyttää HTTPS-salausta. Pääsy henkilötietoihin on rajattu vain henkilöille, joilla on
              tehtäviensä puolesta tarve käsitellä niitä.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
